import { clearAuthSession } from './api';

function logout() {
    clearAuthSession();
    window.open('/', '_self');
}

export default logout;
